import { post } from "@utils/httpUtil";

// 分页查询精彩活动管理列表
export function defaultActivityPageList(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/wonderfulActivity/pageList`, data, config);
}
// 列表复制精彩活动
export function defaultWonderfulActivityById(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/wonderfulActivity/findById`, data, config);
}
// 新建并保存精彩活动
export function defaultActivitySaveOrUpdate(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/wonderfulActivity/saveOrUpdate`, data, config);
}
// 新建并发布精彩活动
export function defaultActivityPublish(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/wonderfulActivity/saveOrUpdate/publish`, data, config);
}
// 列表查询精彩活动专栏开关
export function defaultActivityGetConfig(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/wonderfulActivity/getConfig`, data, config);
}
// 列表开启/关闭精彩活动专栏
export function defaultActivityUpdateConfig(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/wonderfulActivity/updateConfig`, data, config);
}
// 列表发布精彩活动
export function defaultActivityPublishById(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/wonderfulActivity/publishById`, data, config);
}
// 列表结束精彩活动
export function defaultActivityCloseById(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/wonderfulActivity/closeById`, data, config);
}
// 列表删除精彩活动
export function defaultActivityDeleteById(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/wonderfulActivity/deleteById`, data, config);
}
// 列表显示/隐藏精彩活动
export function defaultActivityShowStatusById(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/wonderfulActivity/showStatusById`, data, config);
}
// 列表复制精彩活动
export function defaultActivityCopyById(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/wonderfulActivity/copyById`, data, config);
}
// 分页查询活动明细数据
export function appointmentArrivalActivityParticipatePageList(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/appointmentArrivalActivityParticipate/pageList`, data, config);
}
// 完成任务
export function appointmentArrivalActivityParticipateFinishById(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/appointmentArrivalActivityParticipate/finishById`, data, config);
}
// 未完成任务
export function appointmentArrivalActivityParticipateUnFinishById(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/appointmentArrivalActivityParticipate/unFinishById`, data, config);
}
// 查询明细详情
export function appointmentArrivalActivityParticipateUnFindById(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/appointmentArrivalActivityParticipate/findById`, data, config);
}
// 校验活动名称是否相同
export function wonderfulActivitycheckNameExist(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/wonderfulActivity/checkNameExist`, data, config);
}
// 校验项目名称是否相同
export function specialProjectcheckNameExist(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/specialProject/checkNameExist`, data, config);
}
